export default {
  data() {
    return {
      iconSettings: {
        width: '16px',
        height: '16px',
        color: '#989898',
      },
    }
  },
  computed: {
    accessFields() {
      return [
        {
          key: 'applications',
          attrs: {
            id: 'applications',
            label: 'Аккаунты',
            icon: {
              'icon-name': 'human',
              ...this.iconSettings,
            },
          },
        },
        {
          key: 'finances',
          attrs: {
            id: 'finances',
            label: 'Финансы',
            icon: {
              'icon-name': 'dollar',
              ...this.iconSettings,
            },
          },
        },
        {
          key: 'logs',
          attrs: {
            id: 'logs',
            label: 'Логи',
            icon: {
              'icon-name': 'grading',
              ...this.iconSettings,
            },
          },
        },
        {
          key: 'payments',
          attrs: {
            id: 'payments',
            label: 'Платежи',
            icon: {
              'icon-name': 'creditCard',
              ...this.iconSettings,
            },
          },
        },
        {
          key: 'managers',
          attrs: {
            id: 'managers',
            label: 'Сотрудники',
            icon: {
              'icon-name': 'face',
              ...this.iconSettings,
            },
          },
        },
      ]
    },
  },
}
